export default {
  email: 'Email',
  profile: 'Perfil',
  linkedUser: 'Usuario vinculado',
  group: 'Grupo',
  groups: 'Grupos',
  lastSeen: 'Visto por última vez',
  appVersion: 'Versión de la aplicación'
}
